<div class="modal-header" appCustomAutofocus>
    <h3 *ngIf="!isAdmin">Benefit Window History for {{employeeInfo.FirstName}} {{employeeInfo.LastName}} ({{employeeInfo.Employee}})</h3>
    <h3 *ngIf="isAdmin">Benefit Window History for {{userData.UserFullName}} ({{userData.Employee}})</h3>
</div>
<div class="modal-body">
    <table class="table table-responsive-lg">
        <thead>
            <tr>
                <th>
                    <button type="button" class="button-link" (click)="sortDashboardRows('WindowDisplayName')">
                        <strong>Event Type</strong>
                        <span style="margin-left:5px;" *ngIf="predicate === 'WindowDisplayName' && !reverse">
                            <i class="modus-icons align-bottom">expand_less_bold</i>
                        </span>
                        <span style="margin-left:5px;" *ngIf="predicate === 'WindowDisplayName' && reverse">
                            <i class="modus-icons align-bottom">expand_more_bold</i>
                        </span>
                    </button>
                </th>
                <th>
                    <button type="button" class="button-link" (click)="sortDashboardRows('BenefitUserWindowID')">
                        <strong>Window ID</strong>
                        <span style="margin-left:5px;" *ngIf="predicate === 'BenefitUserWindowID' && !reverse">
                            <i class="modus-icons align-bottom">expand_less_bold</i>
                        </span>
                        <span style="margin-left:5px;" *ngIf="predicate === 'BenefitUserWindowID' && reverse">
                            <i class="modus-icons align-bottom">expand_more_bold</i>
                        </span>
                    </button>
                </th>
                <th>
                    <button type="button" class="button-link" (click)="sortDashboardRows('WindowStartDate')">
                        <strong>Start Date</strong>
                        <span style="margin-left:5px;"
                              *ngIf="predicate === 'WindowStartDate' && !reverse">
                            <i class="modus-icons align-bottom">expand_less_bold</i>
                        </span>
                        <span style="margin-left:5px;" *ngIf="predicate === 'WindowStartDate' && reverse">
                            <i class="modus-icons align-bottom">expand_more_bold</i>
                        </span>
                    </button>
                </th>
                <th>
                    <button type="button" class="button-link" (click)="sortDashboardRows('WindowEndDate')">
                        <strong>Date Completed</strong>
                        <span style="margin-left:5px;" *ngIf="predicate === 'WindowEndDate' && !reverse">
                            <i class="modus-icons align-bottom">expand_less_bold</i>
                        </span>
                        <span style="margin-left:5px;" *ngIf="predicate === 'WindowEndDate' && reverse">
                            <i class="modus-icons align-bottom">expand_more_bold</i>
                        </span>
                    </button>
                </th>
                <th *ngIf="isAdmin">
                    <button type="button" class="button-link" (click)="sortDashboardRows('PRCo')">
                        <strong>PRCo</strong>
                        <span style="margin-left:5px;" *ngIf="predicate === 'PRCo' && !reverse">
                            <i class="modus-icons align-bottom">expand_less_bold</i>
                        </span>
                        <span style="margin-left:5px;" *ngIf="predicate === 'PRCo' && reverse">
                            <i class="modus-icons align-bottom">expand_more_bold</i>
                        </span>
                    </button>
                </th>
                <th *ngIf="isAdmin">
                    <button type="button" class="button-link" (click)="sortDashboardRows('Employee')">
                        <strong>Employee</strong>
                        <span style="margin-left:5px;" *ngIf="predicate === 'Employee' && !reverse">
                            <i class="modus-icons align-bottom">expand_less_bold</i>
                        </span>
                        <span style="margin-left:5px;" *ngIf="predicate === 'Employee' && reverse">
                            <i class="modus-icons align-bottom">expand_more_bold</i>
                        </span>
                    </button>
                </th>
                <th style="font-weight: bold;">Audit Report</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
        <tbody *ngFor="let data of gridDataFilter">
            <tr>
                <td>{{data.WindowDisplayName}}</td>
                <td>{{data.BenefitUserWindowID}}</td>
                <td>{{data.WindowStartDateDisplay}}</td>
                <td>{{data.WindowEndDateDisplay}}</td>
                <td *ngIf="isAdmin">{{data.PRCo}}</td>
                <td *ngIf="isAdmin">{{data.Employee}}</td>
                <td>
                    <a *ngIf="data.AuditReportExists"
                       href="/Approval/GetWindowAuditReportData?benefitUserWindowID={{data.BenefitUserWindowID}}">View</a>
                    <a *ngIf="isAdmin && data.IsApproved && !data.AuditReportExists" class="link" style="cursor:pointer;" (click)="generateReport(data.BenefitUserWindowID)">Generate</a>
                    <div *ngIf="isAdmin && !data.IsApproved && !data.AuditReportExists">Pending Approval</div>
                </td>
                <td>
                    <button type="button" class="btn btn-outline-dark" (click)="viewAttachment(data)"
                            *ngIf="data.HasAttachments">
                        <span class="oi oi-paperclip"></span>
                    </button>
                </td>
            </tr>
            <tr *ngIf="data.showAttachment">
                <td [attr.colspan]="isAdmin ? 8 : 6" style="padding-left:25px;">
                    <div *ngIf="data.attachmentList?.length == 0">There is no attachments.</div>
                    <ng-container *ngFor="let data2 of data.attachmentList">
                        <div *ngIf="data.attachmentList?.length > 0">
                            <a href="/Employee/GetFileAttachmentData?fileAttachmentID={{data2.FileAttachmentID}}">{{data2.AttachmentFileName}}</a>
                        </div>
                    </ng-container>
                </td>
            </tr>
        </tbody>
    </table>
    <pagination class="pagination-sm" [totalItems]="gridData?.length" [(ngModel)]="formData.currentPage"
                [itemsPerPage]="formData.itemsPerPage" (ngModelChange)="updateFilteredDocuments()" [maxSize]="10">
    </pagination>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-dark" (click)="closeClicked()">
        Close
    </button>
</div>